import ServerApi from './$server.api'

export default {
    getAccounts,
    getAccountTotal,
    getAccountShipmentsReport,
    getAccountChargesReport,
    getAccountRefundsReport,
    createAccount,
    updateAccount,
    deleteAccount
}

async function getAccounts(query) {
    return await ServerApi.request('get', '/accounts', {query})
}

async function getAccountTotal(accountId) {
    return await ServerApi.request('get', `/accounts/${accountId}/total`)
}

async function getAccountShipmentsReport(accountId) {
    return await ServerApi.request('get', `/accounts/${accountId}/shipments/report`, { responseType: 'blob'})
}

async function getAccountChargesReport(accountId) {
    return await ServerApi.request('get', `/accounts/${accountId}/charges/report`, { responseType: 'blob'})
}

async function getAccountRefundsReport(accountId) {
    return await ServerApi.request('get', `/accounts/${accountId}/refunds/report`, { responseType: 'blob'})
}

async function createAccount(data) {
    const timezone = new Date().getTimezoneOffset()/60
    const query = {timezone}
    return await ServerApi.request('post', '/accounts', {data, query})
}

async function updateAccount(accountId, data) {
    const timezone = new Date().getTimezoneOffset()/60
    const query = {timezone}
    return await ServerApi.request('put', `/accounts/${accountId}`, {data, query})
}

async function deleteAccount(accountId) {
    return await ServerApi.request('delete', `/accounts/${accountId}`)
}